module.exports = __webpack_public_path__ + "static/media/f_eyeshape_round_amber.3586d8f7.png";